import { render, staticRenderFns } from "./PageNotFound404.vue?vue&type=template&id=c64c6ef4&"
import script from "./PageNotFound404.vue?vue&type=script&lang=js&"
export * from "./PageNotFound404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports